import React from "react";

function Breadcrumb({ title, path }) {
  return (
    <div
      className="site-breadcrumb"
      style={{ background: `url(/assets/img/breadcrumb/01.png)` }}
    >
      <div className="container">
        <h2 className="breadcrumb-title">{title}</h2>

        <ul className="breadcrumb-menu">
          <li>
            <a href="/">Home</a>
          </li>
          <li className="active breadcrumb-path">{path}</li>
        </ul>
      </div>
    </div>
  );
}

export default Breadcrumb;
